<template>
  <div>

    <div class="box">
      <div class="moudleTitle">
        限时抢购<span class="subTitle"></span>
      </div>
      <div class="switch-bar">
        <div :class="acIdx==0?'switchAc':'switch-item'" @click="acIdx=0,getList()">
          <div class="topR"><i class="el-icon-alarm-clock" style="text-align:left;"></i> 抢购中</div>
          <div class="bottom" style="text-align:left;width: 100%;font-size:12px">{{timeCur}}</div>
        </div>|
        <div :class="acIdx==1?'switchAc':'switch-item'" @click="acIdx=1,getList()">明天</div>|
        <div :class="acIdx==2?'switchAc':'switch-item'" @click="acIdx=2,getList()">后天</div>|
        <div :class="acIdx==3?'switchAc':'switch-item'" @click="acIdx=3,getList()">{{day3}}</div>|
        <div :class="acIdx==4?'switchAc':'switch-item'" @click="acIdx=4,getList()">{{day4}}</div>
      </div>
      <div class="moudleGoodsMain">
        <div class="goodsItem  template-hover-shadow" v-for="(item, index) in goodsList" :key="index" @click="toCourseInfo(item)">
          <img :src="item.img" alt="" class="cover">
          <div class="goodsTitle"> {{item.name}}</div>
          <div class="rowDetail">
            <div class="num  template-sign-number">{{item.sellCount}}</div>
            <div class="template-sign-price" @click="toCourseInfo(item)" style="font-size: 24px; color: rgb(252, 94, 94) !important;">
              {{item.snapPrice}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "limit-purchase",
  data () {
    return {
      goodsList: [],
      acIdx: 0,
      timeCur: '',
      day0: '',
      day1: '',
      day2: '',
      day3: '',
      day4: '',
      day5: '',
    };
  },
  methods: {
    countTime (value) {
      //获取当前时间
      var date = new Date();
      var now = date.getTime();

      //设置截止时间
      //在pc端浏览器可以这样写
      console.log('123', this.getDateStr(0) + " 24:00:00")
      var endDate = new Date(this.getDateStr(0) + " 24:00:00");
      //移动端必须这样写，因为ios不支持日期中间是-链接，会报错
      //var endDate = new Date("2019/7/22 00:00:00");
      var end = endDate.getTime();
      //时间差
      var differTime = end - now;
      //定义变量,h,m,s保存倒计时的时间
      var h, m, s;
      if (differTime >= 0) {
        h = Math.floor(differTime / 1000 / 60 / 60);
        m = Math.floor(differTime / 1000 / 60 % 60);
        s = Math.floor(differTime / 1000 % 60);
        h = h < 10 ? ("0" + h) : h;
        m = m < 10 ? ("0" + m) : m;
        s = s < 10 ? ("0" + s) : s;
        var timeDom = "倒计时：" + h + "小时" + m + "分" + s + "秒";
        this.timeCur = timeDom
        //递归调用函数所以是延时器不是定时器
        var _this = this
        setTimeout(function () {
          _this.countTime(value)
        }, 1000);
      } else {
        var timeDom = "00小时 00分 00秒";
        this.timeCur = timeDom
      }
    },
    getDateStr (AddDayCount) {
      var dd = new Date();
      dd.setDate(dd.getDate() + AddDayCount);//获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m = (dd.getMonth() + 1) < 10 ? "0" + (dd.getMonth() + 1) : (dd.getMonth() + 1);//获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();//获取当前几号，不足10补0
      return y + "-" + m + "-" + d;
    },
    getList () {
      // this.api.schoolPageTemplate.getFlashSaleGoodsList({ numTime: (this.acIdx + 1) }).then(res => {
      //   console.log(res)
      // })
      // this.$axios.get(`schoolPage/getFlashSaleGoodsList?numTime=${this.acIdx + 1}`).then(res => {
      //   console.log(res)
      //   this.goodsList = res.data
      // })
      this.api.schoolPageTemplate.getFlashSaleGoodsList({ numTime: (this.acIdx + 1) }).then(res => {
        console.log(res)
      })
    }
  },
  mounted () {
    this.countTime()
    this.day0 = this.getDateStr(0)
    this.day1 = this.getDateStr(1)
    this.day2 = this.getDateStr(2)
    this.day3 = this.getDateStr(3)
    this.day4 = this.getDateStr(4)
    this.day5 = this.getDateStr(5)
    this.getList()
  },
};
</script>
<style lang="less" scoped>
.box {
  width: 1204px;
  margin: 0 auto;
  .switch-bar {
    display: flex;
    background: #fff3f1;
    width: 100%;
    height: 55px;
    border-radius: 6px;
    flex-direction: row;
    margin-bottom: 12px;
    color: #fae3de;
    align-items: center;
    .switch-item {
      width: 204px;
      height: 55px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      padding: 0 16px;
      text-align: center;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      color: #77797a;
      &:hover {
        color: tomato;
      }
    }
    .switchAc {
      width: 204px;
      height: 55px;
      cursor: pointer;
      background: url(https://www-cdn-res.shiguangkey.com/pc-office-wesite/img/6505dd6.png)
        no-repeat;
      background-size: 100% 100%;
      font-weight: 700;
      justify-content: center;
      text-align: center;
      display: flex;
      flex-direction: column;
      padding: 0 16px;
      box-sizing: border-box;
    }
  }
  .topR {
    font-size: 21px;
    width: 100%;
    text-align: left;
    i {
      font-size: 21px;
      text-align: left;
    }
  }
  .moudleGoodsMain {
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
    display: flex;
    .goodsItem {
      width: 285px;
      height: auto;
      border-radius: 5px;
      background: white;
      padding-bottom: 15px;
      .cover {
        width: 285px;
        height: 136px;
      }
      .goodsTitle {
        box-sizing: border-box;
        width: 285px;
        font-size: 16px;
        color: rgb(48, 49, 51);
        text-align: left;
        padding-top: 10px;
        padding-left: 15px;
        padding-bottom: 10px;
      }
      .rowDetail {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 0 16px;
        box-sizing: border-box;
        .num {
          width: 50%;
          font-size: 13px;
          color: rgb(162, 170, 188);
          text-align: left;
          line-height: 30.4px;
        }
        .price {
          box-sizing: border-box;
          width: 50%;
          height: 24px;
          font-size: 12px;
          color: white;
          text-align: center;
          background-color: rgb(252, 94, 94);
          border: none;
          border-radius: 21px;
          font-size: 12px;
          color: white;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/onlineSchool/diyTemplate/limitPurchase.vue